import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTarget = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 50,
	viewBox: "0 0 50.0 50.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 50,
		height: 50,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 25.0 0.0 L 25.0 25.0 L 18.0 25.0 M 18.0 15.0 L 18.0 35.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgTarget;
